<script>
import ScholarshipCompetitionApi from "../../Services/Api/ScholarshipCompetitionApi";
import _ from "lodash";
import MeetingScholarshipStatementsTable from "../../Tables/Meeting/MeetingScholarshipStatementsTable.vue";

const TheStudentRatingTableStatements = () => import("../../Tables/Student/TheStudentRatingTableStatements.vue");
export default {
  name: "TheStudentScholarshipRatingCard",

  props: {
    statements: Array,
    completedStatements: Array,
  },

  data() {
    return {
      tab: null,
    };
  },

  components: {
    MeetingScholarshipStatementsTable,
    TheStudentRatingTableStatements,
  },

  methods: {
    showDimensionsStatements(id) {
      this.$emit('openStatement', id);
    },
  },
}
</script>

<template>
  <v-card
    flat
    outlined
    class="rounded-xl"
  >

    <v-card-title class="pb-0">
      Рейтинг заявлений
      <v-icon right>
        fa-trophy
      </v-icon>
    </v-card-title>
    <v-card-title  class="pb-0 pt-1 pl-0">
      <v-tabs
        class="mb-0 pb-0"
        color="teal darken-3"
        v-model="tab"
      >
        <v-tab key="all-achievement">
          Все
        </v-tab>
        <v-tab key="complete-achievement">
          Подтвержденные
        </v-tab>
      </v-tabs>
    </v-card-title>

    <v-divider/>

    <v-tabs-items v-model="tab">
      <v-tab-item
        key="all-achievement"
      >
        <the-student-rating-table-statements
          :statements="statements"
          @openStatement="showDimensionsStatements"
        />
      </v-tab-item>
      <v-tab-item
        key="complete-achievement"
      >
        <the-student-rating-table-statements
          :statements="completedStatements"
          @openStatement="showDimensionsStatements"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<style scoped>

</style>